export default "/images/right-arrow.png?b2e057e0ae708a02627648042b441dae";